import { useService } from '@nzyme/vue-ioc/useService.js';
import { BrowserLocaleContext } from './BrowserLocaleContext.js';
export function useLocale() {
    return useService(BrowserLocaleContext).locale;
}
//# sourceMappingURL=useLocale.js.map